<template>
	<div class="flex xs-12 bb1 bc7">
		<div
			v-for="(tab, i) in tabs"
			:key="i"
			@click="$emit('tab:clicked', tab)"
			class="cu2 c2 fw7 p4 bb2 bc0"
			:class="{ bc2: tab.isSelected }"
		>
			{{ tab.label }}
		</div>
	</div>
</template>

<script>
export default {
	props: {
		tabs: {
			type: Array,
			default: () => []
		}
	}
}
</script>
